import CustomerSourceList from "./CustomerSourceList";

const CustomerSourceSetupPage = () => <CustomerSourceList />;

export default CustomerSourceSetupPage;
